export function getCompletedColor(defaultColor = 'textPrimary') {
  if (!this.detailedStatus) return 'textPrimary';
  switch (this.detailedStatus) {
    case 'COMPLETED_WITH_DELAY':
      return 'red';
    default:
      return defaultColor;
  }
}

export function getStatusColor(defaultColor = 'textSecondary') {
  if (!this.detailedStatus) return 'textSecondary';
  switch (this.detailedStatus) {
    case 'DELAYED':
      return 'red';
    default:
      return defaultColor;
  }
}
